import { render, staticRenderFns } from "./CV.vue?vue&type=template&id=b444f3f2&"
import script from "./CV.vue?vue&type=script&lang=js&"
export * from "./CV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports